import { useMutation } from "@apollo/client";
import { DOCUMENT_CREATE, DOCUMENT_UPDATE } from "graphql/mutation/document-gql";
import { successNotification } from "components/request-result";
import notifyMutationError from "components/request-result/notify-mutation-error";
import { useTranslation } from "components/use-hooks";

const useMutationDocumentCreateUpdate = (id) => {
  const operation = id ? DOCUMENT_UPDATE : DOCUMENT_CREATE;
  const payloadName = id ? "documentUpdate" : "documentCreate";
  const translations = useTranslation();
  const failedMessage = translations["APP_SETTINGS.Error_InvalidResponse"];
  const [mutate, { loading }] = useMutation(operation);

  const _setDocumentCreateUpdate = async (options) => {
    try {
      const result = await mutate(options);
      const payload = result.data?.[payloadName];
      if (!payload?.document?.id) {
        throw new Error(failedMessage);
      }
      successNotification({ title: payload.label, description: payload.message });
      return payload.document;
    } catch (error) {
      notifyMutationError(error);
      throw error;
    }
  };

  return {
    _setDocumentCreateUpdate,
    loadingMutationDocumentCreateUpdate: loading,
  };
};

export default useMutationDocumentCreateUpdate;
